import { Component, OnInit } from '@angular/core';
import { config, AnnouncementService, MemberQuery, MemberDetails } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { Observable } from 'rxjs';
import { ProductCode } from 'src/app/shared/utilities/product-code';
@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  config = config;
  memberDetails$: Observable<MemberDetails | undefined>;
  screenSize = ScreenType;
  productCode = ProductCode;
  isNavAtEnd: boolean = false;

  constructor(private announcementService: AnnouncementService, private memberQuery: MemberQuery) {}

  ngOnInit() {
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.announcementService.fetchAnnouncements().toPromise();
  }
}
